import React, { useEffect, useState } from "react";
import Checkbox from "../Elements/Checkbox";
import RadioButton from "../Elements/RadioButtonCourse";

function CourseSidebarPageFilter({
  filterLevel,
  setFilterLevel,
  filtering,
  setFiltering,
}) {
  const [checked, setChecked] = useState(false);

  const handleChange = () => {
    setChecked(!checked);
  };

  // for radio button

  const handlePopularFilter = () => {
    setFiltering("desc");
  };

  const handleNewFilter = () => {
    setFiltering("");
  };

  const handleRatingFilter = () => {
    setFiltering("rating");
  };

  const handlePromoFilter = () => {
    setFiltering("promo");
  };

  const handleBeginnerLevel = () => {
    setFilterLevel("1");
  };

  const handleIntermediateLevel = () => {
    setFilterLevel("2");
  };

  const handleAdvanncedLevel = () => {
    setFilterLevel("3");
  };

  const handleAllLevel = () => {
    setFilterLevel("");
  };

  //buat dropdown
  const handleFilterChange = (e) => {
    const selectedValue = e.target.value;
    setFiltering(selectedValue);
  };

  const handleLevelChange = (e) => {
    const selectedValue = e.target.value;
    setFilterLevel(selectedValue);
  };

  return (
    <div>
      {/*radio button pc*/}
      <div className="course__sidebar-widget d-none d-md-block">
        <div className="course__sidebar-info">
          <h4 className="course__sidebar-title">Filter</h4>
          <div className="row">
            <div className="col-6 col-lg-12 d-flex justify-content-start flex-column flex-md-row">
              <RadioButton
                label="Terbaru"
                checked={filtering === ""}
                value=""
                onChange={handleNewFilter}
                name="filter"
              />
            </div>
            <div className="col-6 col-lg-12 d-flex justify-content-start flex-column flex-md-row">
              <RadioButton
                label="Terpopuler"
                checked={filtering === "peserta_desc"}
                value="peserta_desc"
                onChange={handlePopularFilter}
                name="filter"
              />
            </div>
          </div>
        </div>
        <div className="course__sidebar-info mt-3">
          <h4 className="course__sidebar-title">Tingkat</h4>
          <div className="row">
            <div className="col-6 col-lg-12 d-flex justify-content-start flex-column flex-md-row">
              <RadioButton
                label="Semua Tingkat"
                value=""
                checked={filterLevel === ""}
                onChange={handleAllLevel}
                name="level"
              />
            </div>
            <div className="col-6 col-lg-12 d-flex justify-content-start flex-column flex-md-row">
              <RadioButton
                label="Mudah"
                value="1"
                checked={filterLevel === "1"}
                onChange={handleBeginnerLevel}
                name="level"
              />
            </div>
            <div className="col-6 col-lg-12 d-flex justify-content-start flex-column flex-md-row">
              <RadioButton
                label="Sedang"
                value="2"
                checked={filterLevel === "2"}
                onChange={handleIntermediateLevel}
                name="level"
              />
            </div>
            <div className="col-6 col-lg-12 d-flex justify-content-start flex-column flex-md-row">
              <RadioButton
                label="Sulit"
                value="3"
                checked={filterLevel === "3"}
                onChange={handleAdvanncedLevel}
                name="level"
              />
            </div>
          </div>
        </div>
      </div>
      {/*dropdown smartphone*/}
      <div className="course__sidebar-widget d-md-none d-block">
        <div className="course__sidebar-info">
          <h4 className="course__sidebar-title">Filter</h4>
          <div className="row">
            <div className="flex-column d-flex justify-content-start">
              <select
                className="form-select"
                value={filtering}
                onChange={handleFilterChange}
                name="filter"
              >
                <option value="">Terbaru</option>
                <option value="peserta_desc">Terpopuler</option>
              </select>
            </div>
          </div>
        </div>
        <div className="course__sidebar-info mt-3">
          <h4 className="course__sidebar-title">Tingkat</h4>
          <div className="row">
            <div className="flex-column d-flex justify-content-start">
              <select
                className="form-select"
                value={filterLevel}
                onChange={handleLevelChange}
                name="level"
              >
                <option value="">Semua Tingkat</option>
                <option value="1">Mudah</option>
                <option value="2">Sedang</option>
                <option value="3">Sulit</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseSidebarPageFilter;
